import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const buildUnlockHomeworkURL = (groupId) => buildUrl(`/groups/${groupId}/unlock-homework`);


export const FETCH_UNLOCK_HOMEWORK_REQUEST = 'FETCH_UNLOCK_HOMEWORK_REQUEST';
export const FETCH_UNLOCK_HOMEWORK_SUCCESS = 'FETCH_UNLOCK_HOMEWORK_SUCCESS';
export const FETCH_UNLOCK_HOMEWORK_FAILURE = 'FETCH_UNLOCK_HOMEWORK_FAILURE';
export const UPDATE_UNLOCK_HOMEWORKS_REQUEST = 'UPDATE_UNLOCK_HOMEWORKS_REQUEST';
export const UPDATE_UNLOCK_HOMEWORKS_SUCCESS = 'UPDATE_UNLOCK_HOMEWORKS_SUCCESS';
export const UPDATE_UNLOCK_HOMEWORKS_FAILURE = 'UPDATE_UNLOCK_HOMEWORKS_FAILURE';

export function fetchUnlockHomeworkIfNeeded(groupId) {
  const method = 'GET';
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildUnlockHomeworkURL(groupId) })) {
      return false;
    }

    return dispatch(fetchUnlockHomework(groupId));
  };
}

export function fetchUnlockHomework(groupId) {
  return (dispatch) => {
    const url = buildUnlockHomeworkURL(groupId);
    const method = 'GET';

    return dispatch(fetchUnlockHomeworkRequest()).payload
      .then((response) => dispatch(fetchUnlockHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchUnlockHomeworkFailure(error)));

    function fetchUnlockHomeworkRequest() {
      return ApiCall.createAction({
        type: FETCH_UNLOCK_HOMEWORK_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchUnlockHomeworkSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_UNLOCK_HOMEWORK_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchUnlockHomeworkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_UNLOCK_HOMEWORK_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}

export function updateUnlockHomeworks(groupId, unlockHomeworks) {
  return (dispatch) => {
    const url = buildUnlockHomeworkURL(groupId);
    const method = 'PUT';
    return dispatch((updateUnlockHomeworksRequest())).payload
    .then((response) => dispatch(updateUnlockHomeworksSuccess(response)))
    .catch((error) => dispatch(updateUnlockHomeworksFailure(error)));

    function updateUnlockHomeworksRequest() {
      const param = {
        method,
        body: JSON.stringify(unlockHomeworks),
      };
      return ApiCall.createAction({
        type: UPDATE_UNLOCK_HOMEWORKS_REQUEST,
        payload: fetch(url, param),
        url,
        method,
      });
    }

    function updateUnlockHomeworksSuccess(response) {
      return ApiCall.createAction({
        type: UPDATE_UNLOCK_HOMEWORKS_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function updateUnlockHomeworksFailure(error) {
      return ApiCall.createAction({
        type: UPDATE_UNLOCK_HOMEWORKS_FAILURE,
        error,
        url,
        method,
        disableDefault: true,
      });
    }
  };
}




// WEBPACK FOOTER //
// ./data/UnlockHomework/actions.js